<template>
    <reg-tree-list
        :viewName="name"
        :keyExpr="key"
        :dbSchema="matview_schema"
        :dbSource="matview"
        :cardName="cardName"
        apiGetList="kv-customer-vers-list/data/get"
    >
    </reg-tree-list>
</template>

<script>
import RegTreeList from '@/virtual/reg-tree-list.vue';
export default {
    name: 'view-kv-customer-vers',
    data: function () {
        return {
            name: 'view-kv-customer-vers',
            matview_schema: 'pres',
            matview: 'mvi_customer_vers',
            key: 'id',
            cardName: 'version-counteragent-card-vers',
        };
    },
    components: {
        RegTreeList,
    },
};
</script>

<style scoped></style>
